import { createUniqueId } from '../../../utils/helper'

export const BATTLE_LOG = '[BATTLE LOG]'
export const LOG_BATTLE = `${BATTLE_LOG} Log Battle`
export const RESET_LOG = `${BATTLE_LOG} Reset Battle Log`

export const logBattle = ({ actor, action }) => ({
    type: LOG_BATTLE,
    payload: {
        actor,
        action,
        logID: `log_${createUniqueId()}`,
        timestamp: Date.now(),
    },
})
export const resetBattleLog = () => ({
    type: RESET_LOG,
    payload: {},
})
